module.exports = __webpack_public_path__ + "static/media/globe.7751fc62.svg";